import type { TranslationPlaceholder } from '#layers/i18n/types';
import type { SafeKeyOf, SafePick, TranslatableRecord, TranslateObjectOptions } from '#layers/i18n/utils/translate-object';
import { useI18n } from 'vue-i18n';
import { translateObject } from '#layers/i18n/utils/translate-object';
import { translateString } from '#layers/i18n/utils/translate-string';

type BoundOptions<K, P extends boolean> = Omit<TranslateObjectOptions<K, P>, 'i18n'>;

interface UseTranslationUtilsReturn {
	translateString: <S extends TranslationPlaceholder | undefined>(s: S) => S;
	translateObject: {
		<T extends TranslatableRecord, K extends SafeKeyOf<T>>(object: T, options?: BoundOptions<K, false>): T;
		<T extends TranslatableRecord, K extends SafeKeyOf<T>>(object: T, options: BoundOptions<K, true>): SafePick<T, K>;
	};
}

export function useTranslationUtils(): UseTranslationUtilsReturn {
	const i18n = useI18n();

	return {
		translateString: (s) => translateString(s, i18n),
		translateObject: ((object: any, options?: any) => translateObject(object, { ...options, i18n })) as UseTranslationUtilsReturn['translateObject'],
	};
}
